import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Button, Field, Icon, Popup, DatetimePicker, DropdownMenu, DropdownItem, Form, Cell, Collapse, CollapseItem, Overlay, Loading, Swipe, SwipeItem, Checkbox, Tab, Tabs, NoticeBar, CheckboxGroup, CheckBox, Dialog } from 'vant'
import 'vant/lib/index.css'
import "lib-flexible/flexible"
import FastClick from "fastclick"
//storage
import storage from "./tools/storage";
// css
import "@/style/index.css"
// permission
import "@/permission";

import "@/tools/utils"

// import "@/tools/js-sdk.js"

Vue.use(Button);
Vue.use(Field);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(DatetimePicker);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Form);
Vue.use(Cell);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Overlay);
Vue.use(Loading);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Checkbox);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(NoticeBar);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Dialog)
Vue.config.productionTip = false
Vue.prototype.Storage = storage;
Vue.config.ignoredElements = [
  'wx-open-launch-weapp', // 忽略微信开放标签
  // 其他需要忽略的标签...
];

// ios适配
FastClick.attach(document.body)
FastClick.prototype.focus = function (targetElement) {
  let length;
  if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
    length = targetElement.value.length;
    targetElement.focus();
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')